import React, { useEffect, useState } from 'react';
import { FC } from 'react';
import useTranslations from '@hooks/useTranslation';
import { IArchive, IColors, IConferenceItem } from '../../interfaces/Conference';
import { calendarApi } from '../../services/calendar.service';
import { Tab } from './ConferencePhotoGallery.elements';

interface ConferenceProps {
    colors?: IColors;
    archive?: IArchive;
    activeSection?: string;
    index?: string;
    setActiveSection?: Function;
}

const ConferencePhotoGalleryTabTemplate: FC<ConferenceProps> = ({
    colors,
    archive,
    activeSection,
    setActiveSection,
    index,
}) => {
    const { t } = useTranslations();

    const [conference, setConference] = useState<IConferenceItem>();

    const loadConferenceByKey = async (key: string) => {
        const response = await calendarApi.getConferenceKey(key);
        setConference(response.data);
    };

    useEffect(() => {
        if (archive?.conference?._key) {
            loadConferenceByKey(archive?.conference?._key);
        }
    }, [archive?.conference?._key]);

    return (
        <Tab
            colors={colors}
            className={activeSection === `previousTab${index}` ? 'active' : ''}
            onClick={() => setActiveSection(`previousTab${index}`)}
        >
            {conference?.conference?.title}
        </Tab>
    );
};

export default ConferencePhotoGalleryTabTemplate;
